export const recipeLinks = [
    {
        id : 0,
        title: "Overnight, Refrigerator Focaccia",
        link : "https://alexandracooks.com/2018/03/02/overnight-refrigerator-focaccia-best-focaccia/"
    },
    {
        id : 1,
        title: "Homemade Cinnamon Rolls",
        link : "https://www.tastesoflizzyt.com/homemade-cinnamon-rolls/"
    }, {
        id : 2,
        title: "Sticky Mandarin-Vanilla Pound Cake",
        link : "https://food52.com/recipes/87468-best-orange-pound-cake-recipe-with-vanilla-marmalade-glaze"
    }, {
        id : 3,
        title : "Earl Grey Tea Cake With Dark Chocolate and Orange Zest",
        link : "https://cooking.nytimes.com/recipes/1021062-earl-grey-tea-cake-with-dark-chocolate-and-orange-zest"
    }, {
        id : 4,
        title : "Best-Ever Brownies Recipe",
        link : "https://www.biggerbolderbaking.com/best-ever-brownies/"
    }, {
        id : 5,
        title : "Pineapple Poke Cake with Pineapple Glaze",
        link : "https://www.averiecooks.com/pineapple-poke-cake-with-pineapple-glaze/"
    }, {
        id : 6,
        title : "Tres Leches Cake",
        link : "https://tastesbetterfromscratch.com/tres-leches-cake/"
    }, {
        id : 7,
        title : "Homemade Garlic Knots",
        link : "https://sallysbakingaddiction.com/garlic-knots-recipe/"
    }, {
        id : 8,
        title : "Levain Bakery-Style Chocolate Chip Cookies",
        link : "https://www.seriouseats.com/super-thick-chocolate-chip-cookie-recipe"
    }, {
        id : 9,
        title : "Soft Dinner Rolls",
        link : "https://sallysbakingaddiction.com/soft-dinner-rolls/"
    }, {
        id : 10,
        title : "Roasted Garlic and Herb No-Knead Bread",
        link : "https://www.thekitchn.com/roasted-garlic-herb-no-knead-bread-22987118"
    }, {
        id : 11,
        title : "One Bowl Chocolate Chip Banana Bread",
        link : "https://tasty.co/recipe/one-bowl-chocolate-chip-banana-bread"
    }, {
        id : 12,
        title : "Pão de Deus (Portuguese Bread)",
        link : "https://chipabythedozen.com/en/pao-de-deus-portuguese-bread/"
    }, {
        id : 13,
        title : "Artisanal Whole Wheat Bread",
        link : "https://www.biggerbolderbaking.com/whole-wheat-bread-recipe-no-knead/"
    }, {
        id : 14,
        title : "Best Vanilla Cake",
        link : "https://www.recipetineats.com/my-very-best-vanilla-cake/"
    }, {
        id : 15,
        title : "Whole Wheat Sandwich Bread",
        link : "https://tasty.co/recipe/whole-wheat-sandwich-bread"
    }, {
        id : 16,
        title : "Homemade Pizza Dough",
        link : "https://sallysbakingaddiction.com/homemade-pizza-crust-recipe/"
    }, {
        id: 17,
        title : "Sacher Torte",
        link : "https://www.baking-sense.com/2017/12/07/sacher-torte/"
    }, {
        id : 18,
        title : "Classic Tiramisù",
        link : "https://cooking.nytimes.com/recipes/1018684-classic-tiramisu"
    }, {
        id : 19,
        title : "Chocolate Babka",
        link : "https://prettysimplesweet.com/chocolate-babka/"
    }, {
        id : 20,
        title : "Chocolate Crinkle Cookies",
        link : "https://www.allrecipes.com/recipe/9861/chocolate-crinkles-ii/"
    }, {
        id : 21,
        title : "The Best Chocolate Cake",
        link : "https://addapinch.com/the-best-chocolate-cake-recipe-ever/"
    }, {
        id : 22,
        title : "Butterzopf - Swiss Braided Bread",
        link : "https://www.littleswissbaker.com/butterzopf-swiss-braided-bread/"
    }, {
        id : 23,
        title : "Simply Sandwich Bread",
        link : "https://sallysbakingaddiction.com/sandwich-bread/"
    }, {
        id : 24,
        title : "Whole Wheat Quinoa Bread",
        link : "https://www.melskitchencafe.com/whole-wheat-quinoa-bread/"
    }, {
        id : 25,
        title : "Hot Cross Buns",
        link : "https://www.recipetineats.com/hot-cross-buns-recipe/"
    }, {
        id : 26,
        title : "Soft Pretzel Bites",
        link : "https://sallysbakingaddiction.com/soft-pretzel-bites/"
    }, {
        id : 27,
        title : "Crusty Artisan Bread",
        link : "https://www.onceuponachef.com/recipes/crusty-artisan-bread.html"
    }, {
        id : 28,
        title : "Dinner Rolls",
        link : "https://www.joshuaweissman.com/post/greatest-dinner-rolls"
    }, {
        id : 29,
        title : "Chocolate Cupcakes",
        link : "https://addapinch.com/chocolate-cupcakes-recipe/"
    }, {
        id : 30,
        title : "Chocolate Hazelnut Cookies",
        link : "https://cooking.nytimes.com/recipes/1023678-chocolate-hazelnut-cookies"
    }, {
        id : 31,
        title : "Mocha Marble Cookies",
        link : "https://freshbeanbakery.com/mocha-marble-cookies/"
    }, {
        id : 32,
        title : "Crave Rockstar Cookies",
        link : "https://cookingwithkarli.com/crave-rockstar-cookie-recipe/"
    }
]
